import { Pipe, PipeTransform } from '@angular/core';
import { CxDatePipe } from '@spartacus/core';

export interface Options {
  /**
   * Если передать true, то Сегодня/Завтра будет с заглавной буквы
   */
  capitalized?: boolean;
}

/**
 * Обёртка над CxDatePipe с добавлением слов 'Сегодня' и 'Завтра'
 * @param {Date | string} date
 * Дата (если строка, то в формате '31-12-2022')
 * @param {string} format
 * Формат результата (по умолчанию 'dd MMMM' - '31 декабря'), также
 * можно передать фразу например 'Другой день'
 */
@Pipe({
  name: 'uiTodayTomorrowDate',
  standalone: false,
})
export class TodayTomorrowDatePipe implements PipeTransform {
  constructor(private datePipe: CxDatePipe) {}

  transform(rawDate: Date | string, format: string = 'dd MMMM', options: Options = {}): string | null {
    const today = new Date();
    const tomorrow = new Date();
    const date = new Date(rawDate);

    tomorrow.setDate(today.getDate() + 1);

    if (date.toDateString() === today.toDateString()) {
      return options.capitalized ? 'Сегодня' : 'сегодня';
    }

    if (date.toDateString() === tomorrow.toDateString()) {
      return options.capitalized ? 'Завтра' : 'завтра';
    }

    return this.datePipe.transform(date, format);
  }
}
